import { Contract } from "@edp-components/edp-contract";

export class RequestsAndOperations {
    public iconClass: string;
    public colorClass: string;
    public agreementPlanStatus: RequestsAndOperationsAgreementPlanStatus;

    constructor(
        public Channel: string,
        public ContactDetail: string,
        public Message: string,
        public ContractID: string,
        public ContractNumber: string,
        public CreationDate: string,
        public CustomerName: string,
        public DocumentEnabled: boolean,
        public ID: number,
        public LastInteractionDate: string,
        public Motive: string,
        public MotiveAcronym: string,
        public Status: string,
        public Subject: string,
        public Target: string,
        public Type: string,
        public Service: string,
        public ServiceAcronym: string,
        public Description: string,
        public DataOrigin: string,
        public Intervention: Intervention,
        public Details: Detail[] = [],
        public Scheduling?: Scheduling,
        public Task?: Task,
        public Attachments: any[] = [],
        public ExternalCategory: string = null,
        public ObjectId: string = null,
        public FormContact: RequestsAndOperationsFormContact[] = null,
        public SolarContractId: string = null,
        public selected: boolean = false,
        public ServiceId: string = null,
        public MotiveLevel1: string = null,
        public MotiveLevel2: string = null,
        public MotiveLevel3: string = null,
        public captchaToken: string = null
    ) {
        this.setIconClass();
    }

    public isActivo(): boolean {
        return this.Status === "pt.edp.edponline.state.ACTIVO";
    }

    public isInactive(): boolean {
        return this.Status === "pt.edp.edponline.state.INACTIVO";
    }

    public setIconClass() {
        switch (this.Status) {
            case "pt.edp.edponline.support.help.E0005":
            case "pt.edp.edponline.support.help.E0006":
                this.iconClass = "icon-edponline-Bop-070";
                this.colorClass = "warning-title";
                break;
            case "pt.edp.edponline.serviceOrder.status.E0003":
            case "pt.edp.edponline.serviceOrder.status.E0005":
                this.iconClass = "icon-edponline-Bop-035";
                this.colorClass = "awaiting-title";
                break;
            case "pt.edp.edponline.serviceOrder.status.E0004":
                this.iconClass = "icon-edponline-Bop-008";
                this.colorClass = "awaiting-title";
                break;
            case "pt.edp.edponline.support.help.E0007":
            case "pt.edp.edponline.support.help.concluido":
            case "pt.edp.edponline.serviceOrder.status.E0006":
            case "pt.edp.edponline.serviceOrder.status.E0008":
                this.iconClass = "icon-edponline-Bop-072";
                this.colorClass = "success-title";
                break;
            case "pt.edp.edponline.support.help.E0003":
            case "pt.edp.edponline.serviceOrder.status.E0007":
            case "pt.edp.edponline.serviceOrder.status.E0009":
            case "pt.edp.edponline.serviceOrder.status.E0010":
            case "pt.edp.edponline.serviceOrder.status.E0011":
                this.iconClass = "icon-edponline-Bop-071";
                this.colorClass = "error-title";
                break;
            case "pt.edp.edponline.agreementplan.status.E0001":
                this.iconClass = "icon-edponline-Bop-132";
                this.colorClass = "awaiting-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.IN_ANALISYS;
                break;
            case "pt.edp.edponline.agreementplan.status.E0002":
                this.iconClass = "icon-edponline-Bop-070";
                this.colorClass = "warning-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.CLIENT_PENDING;
                break;
            case "pt.edp.edponline.agreementplan.status.E0003":
                this.iconClass = "icon-edponline-Bop-072";
                this.colorClass = "success-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.DONE;
                break;
            case "pt.edp.edponline.agreementplan.status.E0004":
                this.iconClass = "icon-edponline-Bop-071";
                this.colorClass = "error-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.CANCELLED;
                break;
            case "pt.edp.edponline.agreementplan.status.E0005":
                this.iconClass = "icon-edponline-Bop-072";
                this.colorClass = "success-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.REJECTED;
                break;
            case "pt.edp.edponline.agreementplan.status.E0006":
                this.iconClass = "icon-edponline-Bop-071";
                this.colorClass = "error-title";
                this.agreementPlanStatus = RequestsAndOperationsAgreementPlanStatus.CANCELLED_EXPIRED;
                break;
            default:
                this.iconClass = "icon-edponline-Bop-132";
                this.colorClass = "awaiting-title";
        }
    }
}

export class RequestsAndOperationsFactory {
    static create(requestsAndOperations: RequestsAndOperations) {
        return new RequestsAndOperations(
            requestsAndOperations.Channel,
            requestsAndOperations.ContactDetail,
            requestsAndOperations.Message,
            requestsAndOperations.ContractID,
            requestsAndOperations.ContractNumber,
            requestsAndOperations.CreationDate,
            requestsAndOperations.CustomerName,
            requestsAndOperations.DocumentEnabled,
            requestsAndOperations.ID,
            requestsAndOperations.LastInteractionDate,
            requestsAndOperations.Motive,
            requestsAndOperations.MotiveAcronym,
            requestsAndOperations.Status,
            requestsAndOperations.Subject,
            requestsAndOperations.Target,
            requestsAndOperations.Type,
            requestsAndOperations.Service,
            requestsAndOperations.ServiceAcronym,
            requestsAndOperations.Description,
            requestsAndOperations.DataOrigin,
            requestsAndOperations.Intervention,
            requestsAndOperations.Details,
            requestsAndOperations.Scheduling,
            requestsAndOperations.Task,
            requestsAndOperations.Attachments,
            requestsAndOperations.ExternalCategory,
            requestsAndOperations.ObjectId,
            requestsAndOperations.FormContact,
            requestsAndOperations.SolarContractId
        );
    }
}

export interface Detail {
    label: string;
    value: string;
    labelTranslate: string;
}

export interface RequestsAndOperationsAttachment {
    fileId: string;
    fileMime: string;
    filename: string;
    filePath: string;
    fileSize: number;
}

export interface RequestsAndOperationsFormContact {
    label: string;
    labelTranslate: string;
    value: string;
}

export class RequestsAndOperationsFile {
    constructor(
        public name: string,
        public size: string,
        public modified: string,
        public mimeType: string,
        public base64: string = null,
        public id: number = Date.now(),
        public error: string = null
    ) {}
}

export class RequestsAndOperationsFileFactory {
    static create(requestsAndOperationsFile: RequestsAndOperationsFile) {
        return new RequestsAndOperationsFile(
            requestsAndOperationsFile.name,
            requestsAndOperationsFile.size,
            requestsAndOperationsFile.modified,
            requestsAndOperationsFile.mimeType
        );
    }
}

export interface IFilteredRequestsAndOperationsList {
    filtered: RequestsAndOperations[];
    total: number;
}

export interface IRequestsAndOperationsFilter {
    id: number;
    name: string;
    urlName: string;
    allOptionsLabel: string;
    allSelected: boolean;
    options: FilterOption[];
    mobileCollapsable: boolean;
    isMobileFilter: boolean;
    hasOptionSelected: boolean;
    clicked: boolean;
}

export interface FilterOption {
    id: number;
    name: string;
    acronym: string;
    selected: boolean;
    statusCode?: string[];
}

export interface Intervention {
    name: string;
    description: string;
    hasScheduling: boolean;
    hasTracking: boolean;
    tasks: InterventionTasks[];
    action: InterventionAction;
}

export interface InterventionTasks {
    id: number;
    description: string;
    duration: number;
    link: string;
    price: number;
    taskType: InterventionTasksType[];
    title: string;
}

export interface InterventionTasksType {
    id: number;
    code: string;
    name: string;
}

export interface InterventionAction {
    code: string;
    description: string;
}

export interface Scheduling {
    endDate: string;
    startDate: string;
    startTime?: string;
    endTime?: string;
}

export interface Task {
    type: string;
    status: string;
    description: string;
    scheduling: Scheduling;
}

export class RequestsAndOperationsFilter {
    constructor(
        public id: number,
        public name: string,
        public urlName: string,
        public allOptionsLabel: string,
        public allSelected: boolean,
        public options: FilterOption[],
        public mobileCollapsable: boolean = false,
        public isMobileFilter: boolean = false,
        public hasOptionSelected: boolean = false,
        public clicked: boolean = false
    ) {}
}

export interface ITimeSlot {
    from: string;
    to: string;
    label: string;
}

export interface IInterventionDate {
    available: boolean;
    date: string;
    timeSlots: ITimeSlot[];
}

export class RequestsAndOperationsFiltersFactory {
    static generateRequestsAndOperationsFilters(res) {
        if (!res) {
            return [];
        }
        const serviceOptions: FilterOption[] = [];
        res.filter(item => item.acronym !== null).map(item =>
            serviceOptions.push({
                id: item.id,
                name: item.name,
                acronym: item.acronym,
                selected: item.isSelected,
            })
        );
        const statusOptions: FilterOption[] = [
            {
                id: 1,
                name: "pt.edp.edponline.support.help.E0001",
                acronym: "CREATED",
                selected: false,
            },
            {
                id: 2,
                name: "pt.edp.edponline.support.help.E0002",
                acronym: "ASSIGN",
                selected: false,
            },
            {
                id: 3,
                name: "pt.edp.edponline.support.help.E0003",
                acronym: "CANCELED",
                selected: false,
            },
            {
                id: 4,
                name: "pt.edp.edponline.support.help.E0004",
                acronym: "PENDING",
                selected: false,
            },
            {
                id: 5,
                name: "pt.edp.edponline.support.help.E0005",
                acronym: "PENDING",
                selected: false,
                statusCode: ["E0005", "E0006"],
            },
            {
                id: 7,
                name: "pt.edp.edponline.support.help.E0007",
                acronym: "RESOLVED",
                selected: false,
            },
        ];

        const ftrService = new RequestsAndOperationsFilter(
            1,
            "ContractBasicComponentItem.Servicos",
            "Service",
            "pt.edp.edponline.benefits.filters.allCardSubtypes",
            false,
            serviceOptions,
            false,
            false,
            false
        );
        const ftrStatus = new RequestsAndOperationsFilter(
            2,
            "pt.edp.edponline.contract.list.filter.status",
            "Status",
            "pt.edp.edponline.benefits.filters.allCardSubtypes",
            false,
            statusOptions,
            false,
            false,
            false
        );

        return [ftrService, ftrStatus];
    }
}

export interface RequestsAndOperationsList {
    contract: Contract;
    localSupportList: boolean;
}

export enum RequestsAndOperationsTarget {
    CRM = "CRM",
    UI_PATH = "UIPath",
}

export enum RequestsAndOperationsAgreementPlanStatus {
    IN_ANALISYS = "E0001",
    CLIENT_PENDING = "E0002",
    DONE = "E0003",
    CANCELLED = "E0004",
    REJECTED = "E0005",
    CANCELLED_EXPIRED = "E0006",
}

export enum RequestService {
    PAYMENT_AGREEMENT = "Acordo de Pagamento"
}
